export default "__VITE_ASSET__CES6Of6H__"